(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bkp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.setupMobileSearch();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileSearchToggle?.removeEventListener('click', this.onMobileSearchToggleClickHandler);
      this.mobileSearchClose?.removeEventListener('click', this.onMobileSearchCloseClickHandler);
      document.removeEventListener('click', this.onDocumentClickHandler);
      document.removeEventListener('keydown', this.onDocumentKeydownHandler);
    }

    setupMobileSearch() {
      this.mobileSearchToggle = this.querySelector('.header__mobile-search-toggle');
      this.mobileSearchPanel = this.querySelector('.header__mobile-search-panel');
      this.mobileSearchClose = this.querySelector('.header__mobile-search-close');
      this.mobileSearchInput = this.mobileSearchPanel?.querySelector('.search__input');
      this.mobilePredictiveSearch = this.mobileSearchPanel?.querySelector('predictive-search');

      if (!this.mobileSearchToggle || !this.mobileSearchPanel) return;

      this.onMobileSearchToggleClickHandler = this.toggleMobileSearchPanel.bind(this);
      this.onMobileSearchCloseClickHandler = this.handleMobileSearchClose.bind(this);
      this.onDocumentClickHandler = this.handleDocumentClick.bind(this);
      this.onDocumentKeydownHandler = this.handleDocumentKeydown.bind(this);

      this.mobileSearchToggle.addEventListener('click', this.onMobileSearchToggleClickHandler);
      this.mobileSearchClose?.addEventListener('click', this.onMobileSearchCloseClickHandler);
      document.addEventListener('click', this.onDocumentClickHandler);
      document.addEventListener('keydown', this.onDocumentKeydownHandler);
    }

    isAnyPredictiveSearchOpen() {
      return Array.from(this.predictiveSearches || []).some((predictiveSearch) => predictiveSearch.isOpen);
    }

    toggleMobileSearchPanel(event) {
      event.preventDefault();

      if (this.header.classList.contains('mobile-search-open')) {
        this.closeMobileSearchPanel({ returnFocus: true });
      } else {
        this.openMobileSearchPanel();
      }
    }

    openMobileSearchPanel() {
      if (!this.mobileSearchPanel || window.innerWidth >= 990) return;

      this.header.classList.add('mobile-search-open');
      this.mobileSearchToggle?.setAttribute('aria-expanded', true);

      requestAnimationFrame(() => {
        this.mobileSearchInput?.focus();
        if (this.mobileSearchInput?.value) this.mobileSearchInput.select();
      });
    }

    closeMobileSearchPanel({ returnFocus = false, clearSearch = false } = {}) {
      if (!this.mobileSearchPanel) return;

      this.header.classList.remove('mobile-search-open');
      this.mobileSearchToggle?.setAttribute('aria-expanded', false);

      if (this.mobilePredictiveSearch) {
        this.mobilePredictiveSearch.close(clearSearch);
      } else if (clearSearch && this.mobileSearchInput) {
        this.mobileSearchInput.value = '';
      }

      if (returnFocus) this.mobileSearchToggle?.focus();
    }

    handleMobileSearchClose(event) {
      event.preventDefault();
      this.closeMobileSearchPanel({ returnFocus: true, clearSearch: true });
    }

    handleDocumentClick(event) {
      if (!this.header.classList.contains('mobile-search-open')) return;

      if (event.target.closest('.header__mobile-search-panel') || event.target.closest('.header__mobile-search-toggle'))
        return;

      this.closeMobileSearchPanel();
    }

    handleDocumentKeydown(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      if (!this.header.classList.contains('mobile-search-open')) return;

      this.closeMobileSearchPanel({ returnFocus: true });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isAnyPredictiveSearchOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMobileSearchPanel();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMobileSearchPanel();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const desktopMq = window.matchMedia('(min-width: 990px)');
    const hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');

    const bindHover = (details) => {
      if (details.dataset.hoverMenuBound === 'true') return;
      details.dataset.hoverMenuBound = 'true';

      const onEnter = () => details.setAttribute('open', '');
      const onLeave = (event) => {
        if (!details.contains(event.relatedTarget)) details.removeAttribute('open');
      };
      const onFocusOut = (event) => {
        if (!details.contains(event.relatedTarget)) details.removeAttribute('open');
      };

      details._hoverMenuHandlers = { onEnter, onLeave, onFocusOut };
      details.addEventListener('mouseenter', onEnter);
      details.addEventListener('mouseleave', onLeave);
      details.addEventListener('focusout', onFocusOut);
    };

    const unbindHover = (details) => {
      if (details.dataset.hoverMenuBound !== 'true') return;
      const handlers = details._hoverMenuHandlers;
      if (handlers) {
        details.removeEventListener('mouseenter', handlers.onEnter);
        details.removeEventListener('mouseleave', handlers.onLeave);
        details.removeEventListener('focusout', handlers.onFocusOut);
      }
      delete details._hoverMenuHandlers;
      delete details.dataset.hoverMenuBound;
    };

    const updateHoverMenus = () => {
      const enableHover = desktopMq.matches && hoverMq.matches;
      document.querySelectorAll('header-menu details').forEach((details) => {
        if (enableHover) bindHover(details);
        else unbindHover(details);
      });
    };

    updateHoverMenus();
    desktopMq.addEventListener('change', updateHoverMenus);
    hoverMq.addEventListener('change', updateHoverMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
